import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { sitecoreAxios } from './core.axios.js';
import { AccessCodes } from './typings.access-codes.js';
import { buildUrl } from './util.build-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS
});
function getTools(portalId, options) {
  const url = buildUrl(`/api/v1/portals/${portalId}/tools`, options);
  return cache(!(options == null ? void 0 : options.disableCache) ? url : void 0, async () => {
    try {
      const response = await sitecoreAxios.get(url);
      return extractTools(response.data);
    } catch {
      return [];
    }
  }).getStaleWhileRevalidate();
}
function extractTools(tools) {
  return tools.map((tool) => {
    return {
      accessCode: tool.access ?? AccessCodes.ALLOWED,
      specs: `width=${tool.settings.width},height=${tool.settings.height},fullscreen=${tool.settings.fullscreen ? "yes" : "no"},toolbar=${tool.settings.toolbar ? "yes" : "no"},menubar=${tool.settings.menubar ? "yes" : "no"},scrollbars=${tool.settings.scrollbars ? "yes" : "no"},resizable=${tool.settings.resizable ? "yes" : "no"}`,
      subtitle: tool.subtitle,
      title: tool.title,
      url: tool.url
    };
  });
}

export { getTools };
//# sourceMappingURL=request.get-tools.js.map
